import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackClarityEvent } from "../utlis/ClarityAnalytics";
import { CLARITY_EVENTS } from "../utlis/EventTypes";
import { trackFirebaseEvent } from "./FirebaseAnalytics";

export const useClarityPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const payload = {
      path: location.pathname,
    };
    trackFirebaseEvent(CLARITY_EVENTS.PAGE_VIEW, payload);
    trackClarityEvent(CLARITY_EVENTS.PAGE_VIEW, payload);
  }, [location.pathname]);
};